import { useTranslation } from 'react-i18next';

import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import RoundedInput from 'components/desktop/_general/Input/RoundedInput/RoundedInput';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const AccessoryDensityCard = ({ state, handlers }: AccessoryTabProps): JSX.Element => {
	const { t } = useTranslation();
	const isAccessoryEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEACCESSORY,
	]);

	const getLabelDensity = (): string => {
		return `${t('_general:DENSITY')} (${t('measurments:GRAMMS_PER_QUBIC_CM')})`;
	};
	return (
		<FoldableCard
			dataComponentType="accessory-density-card"
			defaultOpen={true}
			title={t('_general:DENSITY')}
			content={
				<div className="card-body">
					<label>{getLabelDensity()}</label>
					<RoundedInput
						disabled={!isAccessoryEditor}
						error-key="Density"
						handleChange={handlers.setDensity}
						name="density"
						value={state.density ?? 0}
					/>
				</div>
			}
		/>
	);
};
